<template>
  <div class="hlme">
    <Menu :cgInfo=wwwConfig />
    <div class="home_head_wrap" v-touch:swipe.left="touchLeft" v-touch:swipe.right="touchRight">
      <div class="head_bg_wrap">
        <div v-for="(item, pgIndex) in pluginList" :key="item.name" :class="['head_bg_item', `head_bg_item_${item.key}` ,pgIndex + 1 == currIdx ? 'active' : '', (pgIndex !== 0 && pgIndex !== 1) ? 'others' : '']">
            <img class="title_img" :src="item.textImg" alt="" draggable="false">
            <p class="bnrtText">{{ item.desc }}</p>
            <div class="bg_img_wrap" v-if="item.key === 'perform'">
              <img class="bg_img" :src="item.bgimg" alt="" draggable="false">
              <div class="video_wrap">
                <video
                  preload="auto"
                  id="peform_video_item"
                  muted
                  autoplay
                  loop
                  playsinline
                  playsinlinex5-video-player-type="h5"
                  x5-video-player-fullscreen="true"
                  x5-playsinline="true"
                  x-webkit-airplay="allow"
                  x5-video-orientation="landscape|portrait"
                  webkit-playsinline="true"
                  x5-video-player-type="h5-page"
                >
                  <source
                    src="https://todeskcdnspeed.todesk.com/videos/banner.mp4"
                    type="video/mp4"
                  />
                  您的浏览器不支持视频播放。
                </video>
              </div>
            </div>
            <div class="bg_img_wrap" v-else>
              <img class="bg_img" :src="item.bgimg" alt="" draggable="false">
            </div>
          </div>
      </div>
      <div class="head_opt_wrap">
        <div v-if="currIdx === 2" class="daas">
          <a href="https://pc.todesk.com/download" target="_self" id="bnr_daas_btn">
            <p class="first-order">全功能</p>
            立即下载
          </a>
        </div>
        <div v-else :class="['bnrtBtns', currIdx !== 1 ? 'gray' : '']">
          <router-link to="/download" class="bnrtBtn1" id="bnr_free_btn">个人版免费下载</router-link>
          <router-link to="/enterprise" class="bnrtBtn2" id="index_bnr_ep_btn1" data-btn="v1_index_bnr_ep_btn1">企业版免费试用</router-link>
        </div>
        <div class="down-btn-info">
          <a v-if="currIdx === 2" class="down-text-btn" target="_blank" href="https://www.wjx.cn/vm/Q70Vx70.aspx">
            <span class="text">共创体验官招募</span>
            <img class="icon" src="@/assets/home/right_1.svg" alt="">
          </a>
        </div>
        <div class="bn_swipe_indicator">
          <div  v-for="(item, idIndex) in pluginList" :class="['indicator_item', idIndex + 1 == currIdx ? 'active' : '']"
          @click="swipePlugin(idIndex)" :key="item.name">
            <div :class="`plugin_icon plugin_icon_${item.key}`"></div>
            <div class="process_box">
              <div class="process_ing" :style="idIndex + 1 == currIdx ? `width: ${stepCounter / STEP * 100}%;` : `width: 0px;`"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <DesktronBanner />
    <IndexData :cgInfo="cgInfo" />
    <ScrollUsers class="home_su_wrap" />
    <Technology/>
    <HdcmprV2/>
    <Enterprise/>
    <Security/>
    <Scenes/>
    <Exhibition/>
    <router-link class="td_free_dl"  to="/download">
      <p class="td_brand_title">ToDesk，让远程协同</p>
      <p class="td_brand_title">更简单、更高效</p>
			<p class="td_brand_subTitle">先进高性能的产品助您实现效率的提升</p>
      <div class="td_dl_btn">免费下载</div>
    </router-link>
    <div class="ep_ex_dt">
      <p class="ep_ex_title blue">ToDesk企业版</p>
      <p class="ep_ex_title">为您提供系统化解决方案</p>
      <p class="ep_ex_desc">技术支持、高性能远程安全办公、IT运维</p>
      <div class="btn_wrap">
        <router-link to="/enterprise" class="dt_btn">了解更多</router-link>
        <router-link to="/contact_mobile" class="go_contact">联系我们</router-link>
      </div>
    </div>
    <Footer />
  </div>
</template>
<script>
import Menu from '@/components/menu'
import Footer from '@/components/footer'
import IndexData from '@/components/Common/IndexData'
import ScrollUsers from '@/components/ScrollUsers'
import Technology from '@/components/Home/Technology'
import HdcmprV2 from '@/components/Home/HdcmprV2'
import Enterprise from '@/components/Home/Enterprise'
import Security from '@/components/Home/Security'
import Scenes from '@/components/Home/Scenes'
import Exhibition from '@/components/Home/Exhibition'
import DesktronBanner from '@/components/Desktron/Banner'
import { dealConfig, videoReady } from "../utils/util";
export default {
  components: {
    Menu,
    Footer,
    IndexData,
    ScrollUsers,
    Technology,
    HdcmprV2,
    Enterprise,
    Security,
    Scenes,
    Exhibition,
    DesktronBanner,
  },
  data() {
    return {
      swipeTimer: null,
      doneTimer: null,
      currIdx: 1,
      stepCounter: 0,
      pluginList: [
        {
          key: 'todesk',
          name: 'ToDesk',
          desc: '轻松打破物理限制，随时随地高效使用所有计算终端',
          bgimg: 'https://todeskcdnspeed.todesk.com/2023111717571260a562908ba2f0.png',
          textImg: 'https://todeskcdnspeed.todesk.com/202305111411325fb64dc2a1687c.png',
        },
        {
          key: 'daas',
          name: '云图形工作站',
          desc: '随时随地为你提供一个稳定、流畅、高性能的创作体验',
          bgimg: 'https://todeskcdnspeed.todesk.com/20241101120113625d1fc6d17d6c.png',
          textImg: 'https://todeskcdnspeed.todesk.com/202411051844446262816e236dc0.png'
        },
      ],
      STEP: 20,
      TIMEINTERVAL: 3000,

      cgInfo: {
        // 测试数据
        month_connect: '每月40亿+',
        total_install: '',
        total_user: '1.5亿+',
        total_enterprise: '30万+',
      },
      isPlay:false,
      wwwConfig: null,
    }
  },
  async created() {
    let res = await this.$serve.getConfig({
      type: 2,
    });
    this.wwwConfig = dealConfig(res.data.list);
  },
  watch: {
    currIdx: {
      handler(val) {
        if (val === 2) {
          setTimeout(() => {
            const videoItem = document.querySelector('#peform_video_item')
            if (videoItem) {
              videoItem.currentTime = 0
              videoItem.play()
            } else {
              console.error('找不到视频')
            }
          }, 0);
        }
      },
    }
  },
  beforeDestroy() {
    clearInterval(this.swipeTimer)
    this.swipeTimer = null
    window.removeEventListener('scroll', this.handleScroll)
  },
  mounted(){
    this.setSwipeTimer()
    window.addEventListener('scroll', this.handleScroll);
    videoReady()
  },
  methods:{
    touchLeft() {
			if(this.currIdx == this.pluginList.length){
        this.swipePlugin(0);
      }else{
        this.swipePlugin(this.currIdx);
      }
		},
		touchRight() {
			if(this.currIdx == 1){
        this.swipePlugin(this.pluginList.length - 1);
      }else{
        this.currIdx --;
        this.swipePlugin(this.currIdx - 1);
      }
		},
    swipePlugin(index) {
      this.currIdx = index + 1
      clearInterval(this.swipeTimer)
      this.swipeTimer = null
      this.stepCounter = 20;
      // if (this.currIdx === index + 1)  {
      //   if (this.stepCounter === this.STEP) {
      //     clearInterval(this.swipeTimer)
      //     this.swipeTimer = null
      //     this.stepCounter = 20
      //     if (this.doneTimer) {
      //       clearTimeout(this.doneTimer)
      //       this.doneTimer = null
      //     }
      //     this.doneTimer = setTimeout(() => {
      //       clearTimeout(this.doneTimer)
      //       this.doneTimer = null
      //       this.stepCounter = 0
      //       this.setSwipeTimer()
      //     }, 3000);
      //   } else {
      //     return
      //   }
      // } else {
      //   this.currIdx = index + 1
      //   clearInterval(this.swipeTimer)
      //   this.swipeTimer = null
      //   this.stepCounter = 0
      //   this.setSwipeTimer()
      // }
    },
    setSwipeTimer() {
      if (this.swipeTimer) return
      const TIMEINTERVAL = this.TIMEINTERVAL
      const STEP = this.STEP
      this.swipeTimer = setInterval(() => {
        this.stepCounter++
        if (this.stepCounter == STEP) {
          if (this.currIdx == this.pluginList.length) {
            this.currIdx = 1
            this.stepCounter = 0
          } else {
            this.currIdx++
            this.stepCounter = 0
          }
        }
      }, TIMEINTERVAL / STEP)
    },
    handleScroll() {
      const scrollTop = document.documentElement.scrollTop || 0
      if (scrollTop > 800) {
        clearInterval(this.swipeTimer)
        this.swipeTimer = null
      } else {
        this.setSwipeTimer()
      }
    },
  },
};
</script>
<style lang="less" scoped>
@import '../assets/style/reset.css';
.hlme{
  background: #fff;
  .home_head_wrap {
    position: relative;
    width: 100%;
    height: 585px;
    .head_bg_wrap {
      position: absolute;
      top: 0;
      z-index: 1;
      width: 100%;
      height: 100%;
      background-size: 375px auto;
      background-repeat: no-repeat;
      background-position: top center;
      background-image: url('https://todeskcdnspeed.todesk.com/20230901164449604482c63ba534.png');
      .head_bg_item {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        z-index: 0;
        opacity: 0;
        background-size: auto 100%;
        background-repeat: no-repeat;
        &.others {
          .bnrtText {
            color: #fff;
          }
        }
        &_perform {
          background-image: url('https://todeskcdnspeed.todesk.com/20230908121003604d126ab63f50.png');
        }
        &_daas {
          background-image: url('https://todeskcdnspeed.todesk.com/2024080118012061e9c4ae1d9470.png');
        }
        &_plugin_game {
          background-image: url('https://todeskcdnspeed.todesk.com/20230908123147604d1745fec6fc.png');
        }
        &_plugin_board {
          background-image: url('https://todeskcdnspeed.todesk.com/20230908123203604d1755205f60.png');
        }
        &_plugin_color {
          background-image: url('https://todeskcdnspeed.todesk.com/20230908123227604d176c3b92dc.png');
        }
        &_plugin_screens {
          background-image: url('https://todeskcdnspeed.todesk.com/20230908123248604d1780874864.png');
        }
        &_plugin_virtual {
          background-image: url('https://todeskcdnspeed.todesk.com/20230908123306604d1791bb1618.png');
        }
        .title_img {
          width: auto;
          height: 69.33px;
          display: block;
          margin: 27px auto 0;
        }
        .bnrtText {
          width: 342px;
          height: 55px;
          color: #747576;
          font-family: PingFang SC;
          font-size: 14px;
          font-weight: 400;
          line-height: normal;
          margin: 0 auto;
          display: flex;
          align-items: center;
          justify-content: center;
          text-align: center;
        }
        .bg_img_wrap {
          width: 100%;
          height: 192px;
          margin-top: 5px;
          display: flex;
          align-items: center;
          justify-content: center;
          position: relative;
          .bg_img {
            width: auto;
            height: 192px;
            display: block;
            position: relative;
            z-index: 1;
          }
          .video_wrap {
            width: 218px;
            height: 138px;
            position: absolute;
            bottom: 23px;
            left: 50%;
            transform: translateX(-50%);
            overflow: hidden;
            z-index: 0;
            video {
              width: 272px;
              height: auto;
              object-fit: cover;
            }
          }
        }
        &.active {
          z-index: 1;
          opacity: 1;
        }
      }
    }
    .head_opt_wrap {
      position: relative;
      z-index: 2;
      width: 100%;
      height: 100%;
      box-sizing: border-box;
      padding-top: 374px;
      .bnrtBtns{
        width: 100%;
        display: flex;
        &.gray {
          .bnrtBtn2{
            border-color: #f7f9fc;
            background: hsla(0,0%,100%,.1);
            color: #fff;
          }
          .bnrtBtn2:active {
            color: rgba(255, 255, 255, 0.8);
            background: rgba(255, 255, 255, 0.20);
          }
        }
        .bnrtBtn1{
          box-sizing: border-box;
          width: 123px;
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: #0070F9;
          border-radius: 6px;
          margin-right: 20px;
          margin-left: auto;
          font-family: 'PingFang SC';
          font-weight: 500;
          font-size: 14px;
          line-height: 20px;
          color: #FFFFFF;
        }
        .bnrtBtn1:active {
          background: #1c87fd;
        }
        .bnrtBtn2{
          margin-right: auto;
          box-sizing: border-box;
          width: 123px;
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: #fff;
          border: 1px solid #016EFD;
          border-radius: 6px;
          font-family: 'PingFang SC';
          font-weight: 500;
          font-size: 14px;
          line-height: 20px;
          color: #0070F9;
          border: 1px solid rgb(229, 230, 235);
        }
        .bnrtBtn2:active {
          border: 1px solid rgb(217, 218, 223);
          background-color: rgba(255, 255, 255, 0.9);
          color: #1c87fd;
        }
      }
      .bn_swipe_indicator {
        width: 100%;
        margin: 0 auto;
        overflow-x: auto;
        user-select: none;
        display: flex;
        justify-content: center;
        margin-top: 25px;
        &::-webkit-scrollbar {
          display: none;
        }
        .indicator_item {
          width: 28.93px;
          height: 31px;
          box-sizing: border-box;
          display: flex;
          flex-direction: column;
          align-items: center;
          font-size: 16px;
          color: #9E9E9F;
          margin-right: 12px;
          flex-shrink: 0;
          cursor: pointer;
          transition: border-color .3s;
          border-radius: 6px;
          overflow: visible;
          &.active {
            color: #0070F9;
            .plugin_icon {
              width: 16px;
              height: 16px;
              background-size: 100% auto;
              background-repeat: no-repeat;
              &_todesk {
                background-image: url('~@/assets/home/todesk-active.png');
              }
              &_perform {
                background-image: url('~@/assets/home/perform.png');
              }
              &_daas {
                background-image: url('~@/assets/home/daas-active.png');
              }
              &_plugin_game {
                background-image: url('~@/assets/home/game-active.png');
              }
              &_plugin_board {
                background-image: url('~@/assets/home/broad-active.png');
              }
              &_plugin_color {
                background-image: url('~@/assets/home/color-active.png');
              }
              &_plugin_screens {
                background-image: url('~@/assets/home/screens-active.png');
              }
              &_plugin_virtual {
                background-image: url('~@/assets/home/virtual-active.png');
              }
            }
          }
          &:last-of-type {
            margin-right: 0;
          }
          .plugin_icon {
            width: 16px;
            height: 16px;
            margin: 0 auto;
            background-size: 100% auto;
            background-repeat: no-repeat;
            flex-shrink: 0;
            &_todesk {
              background-image: url('~@/assets/home/todesk-gray.png');
            }
            &_perform {
              background-image: url('~@/assets/home/perform-gray.png');
            }
            &_daas {
              background-image: url('~@/assets/home/daas-gray.png');
            }
            &_plugin_game {
              background-image: url('~@/assets/home/game-gray.png');
            }
            &_plugin_board {
              background-image: url('~@/assets/home/broad-gray.png');
            }
            &_plugin_color {
              background-image: url('~@/assets/home/color-gray.png');
            }
            &_plugin_screens {
              background-image: url('~@/assets/home/screens-gray.png');
            }
            &_plugin_virtual {
              background-image: url('~@/assets/home/virtual-gray.png');
            }
          }
          .process_box {
            width: 24px;
            height: 1.75px;
            border-radius: 14px;
            background-color: #CED0D4;
            overflow: hidden;
            margin: 2px auto 0;
            .process_ing {
              width: 0px;
              height: 100%;
              background-color: #0070F9;
              transition: width .1s;
            }
          }
        }
      }
      .down-btn-info{
        display: flex;
        align-items: center;
        margin-top: 18px;
        height: 24px;
        .down-text-btn{
          display: flex;
          align-items: center;
          color: #0C85AC;
          height: 24px;
          margin: 0 auto;
          .text{
            font-size: 14px;
            line-height: 24px;
            margin-top: 1px;
          }
          .icon{
            width: 12px;
            height: 24px;
            margin-left: 4px;
          }
          &:active {
            opacity: 0.9;
          }
        }
      }
    }
  }
  .home_su_wrap {
    padding-bottom: 30px;
    background-color: #fff;
  }
  .td_free_dl {
    width: 100%;
    height: 219px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    box-sizing: border-box;
    background-image: url('https://todeskcdnspeed.todesk.com/20230919155746605b19d4ecb968.png');
    background-size: 375px auto;
    background-repeat: no-repeat;
    .td_brand_title {
      color: #FFF;
      text-align: center;
      font-family: PingFang SC;
      font-size: 26px;
      font-weight: 600;
      line-height: normal;
    }
    .td_brand_subTitle {
      color: rgba(255, 255, 255, 0.78);
      text-align: center;
      font-family: PingFang SC;
      font-size: 14px;
      font-weight: 400;
      line-height: normal;
      margin-top: 10px;
    }
    .td_dl_btn {
      display: block;
      border-radius: 6px;
      width: 180px;
      height: 40px;
      margin: 0 auto;
      background: rgba(0, 112, 249, 1);
      transition: background-color .3s;
      color: #fff;
      font-family: PingFang SC;
      font-size: 16px;
      font-weight: 400;
      letter-spacing: 0px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 20px;
    }
    &:active {
      .td_dl_btn {
        background-color: #1c87fd;
      }
    }
  }
  .ep_ex_dt {
    background-color: #fff;
    width: 375px;
    height: 248px;
    background-image: url('https://todeskcdnspeed.todesk.com/20230907193558604c3438f5de08.png');
    background-repeat: no-repeat;
    background-size: 375px auto;
    background-position: center bottom;
    .ep_ex_title {
      width: 335px;
      margin: 0 auto;
      color: #444546;
      font-family: PingFang SC;
      font-size: 20px;
      font-weight: 500;
      line-height: normal;
      text-align: center;
      &.blue {
        color: #0070F9;
        font-weight: 600;
        padding-top: 39px;
      }
    }
    .ep_ex_desc {
      width: 335px;
      margin: 0 auto;
      color: #747576;
      font-family: PingFang SC;
      font-size: 14px;
      font-weight: 400;
      line-height: normal;
      text-align: center;
      margin-top: 10px;
    }
    .btn_wrap {
      margin-top: 29px;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      .dt_btn {
        width: 159px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 6.667px;
        border: 1px solid transparent;
        background: #0070F9;
        color: #FFF;
        text-align: center;
        font-family: PingFang SC;
        font-size: 13.333px;
        font-weight: 500;
        letter-spacing: 0.333px;
        margin-right: 17px;
        &:active {
          background-color: #1c87fd;
        }
      }
      .go_contact {
        width: 159px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 6.667px;
        border: 1px solid rgba(0, 112, 249, 1);
        background: #fff;
        color: #0070F9;
        text-align: center;
        font-family: PingFang SC;
        font-size: 13.333px;
        font-weight: 500;
        letter-spacing: 0.333px;
        &:active {
          border: 1px solid #1c87fd;
          background-color: rgb(250, 250, 250);
        }
      }
    }
  }
  .daas{
    display: flex;
    .first-order{
      position: absolute;
      z-index: 2;
      background: linear-gradient(100.54deg, #C956FF -2.99%, #FF834E 100.68%);
      height: 22px;
      width: max-content;
      text-align: center;
      padding: 0 8px;
      border-radius: 4px;
      color: #fff;
      top: -11px;
      right: -20px;
      display: flex;
      justify-content: center;
      align-items: center;
      letter-spacing: 1px;
    }
    #bnr_daas_btn{
      position: relative;
      margin: 0 auto;
      width: 257px;
      height: 40px;
      background-color: #11bbf2;
      border-color: #11bbf2;
      border-radius: 6px;
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #FFFFFF;
      text-align: center;
      color: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
      &:hover{
        opacity: 0.8;
      }
      &:active{
        opacity: 0.9;
      }
    }
  }
}
</style>
